module.exports = __webpack_public_path__ + "assets/img/DP-2.6455e646.jpg";